import React from 'react';
import { Box, Typography } from '@mui/material';
import { useBillingAlertsSummary } from './useBillingAlertsSummary';
import { SnapshotBand } from './SnapshotBand';
import { RangeBand } from './RangeBand';
import { AccountsBlock } from './AccountsBlock';
import { OrphanUsageGroup } from './OrphanUsageGroup';
import { FailedPaymentsBlock } from './FailedPaymentsBlock';
import { PeriodFilter, usePeriodRange } from './PeriodFilter';

/**
 * Écran d'alertes facturation : ce que Quanti paie sans contrepartie.
 *
 * Lecture seule, et volontairement : aucune coupure, aucun email, aucune action
 * automatique. L'écran rend le problème visible, la décision reste humaine.
 *
 * L'ordre vertical porte une distinction : au-dessus du filtre, l'état courant,
 * qui ne dépend d'aucune période ; en dessous, les seules mesures de
 * consommation. Séparer les deux est un point dur — ce qui décrit un état
 * courant ne doit pas se lire comme s'il bougeait avec la plage.
 */
export const BillingAlerts: React.FC = () => {
	const { range, setRange } = usePeriodRange();
	const summary = useBillingAlertsSummary(range);

	return (
		<Box sx={{ p: 2 }}>
			<Typography variant="h6" gutterBottom>
				Alertes facturation
			</Typography>
			<Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2, maxWidth: '60rem' }}>
				Un billing account par ligne : son abonnement, la dernière exécution d'un de ses
				process, et la conso de ses projets managés — ceux dont Quanti paie le
				datawarehouse. Écran de lecture seule.
			</Typography>

			<SnapshotBand summary={summary} />
			<PeriodFilter range={range} onChange={setRange} />
			<RangeBand summary={summary} range={range} />

			<FailedPaymentsBlock />
			<AccountsBlock range={range} />
			{/* Encart séparé, et pas une ligne du tableau ci-dessus : ces consos
			    n'appartiennent à aucun billing account. */}
			<OrphanUsageGroup range={range} />
		</Box>
	);
};
